import styled from 'styled-components';

const MyDiv = styled.div`
.declaration{
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px 6px;
    gap: 7px;
    width: 145px;
    height: 36px;
    left: 571px;
    top: 140px;
    background: rgba(0, 128, 0, 0.06);
    border: 1px solid #008000;
    border-radius: 60px;
}

.regime {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px 5px 4px 11px;
    width: 235px;
    height: 39px;
    left: 727px;
    top: 137px;
    background: rgba(221, 238, 204, 0.06);
    border: 1px solid #0000FF;
    border-radius: 60px;
}

.old {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    gap: 10px;
    width: 130px;
    height: 31px;
    background: #0000FF;
    border-radius: 64px;
    color:white;
}
  .tag {
    background: #E6F4EA;
    color: #2F855A;
    font-size: 12px;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 8px;
  }

  .tag-blue {
    background: #EDF2FF;
    color: #3B82F6;
  }
  .main{
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    background-color: #F9F9F9;
    border-radius:12px;
}
.col{
    color:rgba(0, 0, 0, 1)
}

.section-card {
    background: #FFFFFF;
    border-radius: 12px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    padding: 24px;
  }

.reject{
  color:#D92F34;
  background-color: #FF00001A;
  &:hover{
  color:#D92F34;
  background-color: #FF00001A;
  }
}
.accept{
  color:white;
  background-color: #00B103;
  &:hover{
  color:white;
  background-color: #00B103;
  }
}

 /* Accepted View Styles */

   .head{
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    background-color: #F9F9F9;
    border-top-right-radius: 25px;
    border-top-left-radius: 25px;

}
  .accepted-view {
    background: white;
    // padding: 24px;
    border-radius: 12px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  }

  .deductions-table {
    th, td {
      padding: 12px 56px;
      text-align: left;
      border-bottom: 1px solid #EAECF0;
    }

    th {
      background-color: #D9D9D9;
    }
  }



  .rejected-text {
    color: #FF0000 !important;
  }
 
`;

export default MyDiv;
